import React, { Component, version } from "react";
import { Link } from "react-router-dom";

import Swal from "sweetalert";
import Swal2 from "sweetalert2";
import Cookies from "universal-cookie"
import PropTypes from "prop-types"
import {setLanguage, translate} from 'react-switch-lang'; 

import { slide as Menu } from 'react-burger-menu'

import "../styles/Burger.css"

var styles = {
    bmBurgerBars: {
      background: 'white'
    },
    
    bmBurgerBarsHover: {
      background: 'white',
      opacity: '1'
    },

    bmMenu: {
        background: 'rgb(55, 58, 71,0.8)',
        fontSize: '1.15em',
        
      },
    
    burgerMenu: {
        top: '0',
    },

    bmOverlay: {
        background: ''
      }
}

const disclaimerTextUrl = "<ul>"+
  "<li> <a target='_blank' class='thirdPartyLink' href='https://www.flaticon.com/free-icons/stop-sign' title='stop sign icons'>Stop sign icons created by Freepik - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/worker' title='worker icons'>Worker icons created by Freepik - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/error' title='error icons'>Error icons created by Freepik - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/logo' title='logo icons'>Logo icons created by Freepik - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/react' title='react icons'>React icons created by Kiranshastry - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/pizza' title='pizza icons'>Pizza icons created by Freepik - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/veterinary' title='veterinary icons'>Veterinary icons created by Freepik - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/comment' title='comment icons'>Comment icons created by apien - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/stopwatch' title='stopwatch icons'>Stopwatch icons created by Freepik - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/developer' title='developer icons'>Developer icons created by Freepik - Flaticon</a> </li> "+
  "<li> <a target='_blank' class='thirdPartyLink'  href='https://www.flaticon.com/free-icons/portfolio' title='portfolio icons'>Portfolio icons created by Freepik - Flaticon</a>  </li> "+
  "</ul>"

const builVersion = 1.4;

class BurgerMenu extends Component{

  constructor(props){
    super(props);
    const cookieLanguage = new Cookies('language');
    const lang = cookieLanguage.get('language');
    const {t} = this.props;

    setLanguage(lang);
    
}

  handleSetLanguage = (key) =>{
    setLanguage(key);
  }

  handleClickLanguage = () =>{

    const {t} = this.props;
    const cookieLanguage = new Cookies('language');

      Swal({
      title: t('languageTitle'),
      buttons: {
          sp: {
              text: "Español",
              value: "sp"
          },
          en: {
              text: "English",
              value: "en"
          }
      }

  }).then((value)=>{

    const current = new Date();
    const nextYear = new Date();
     nextYear.setFullYear(current.getFullYear() + 1);

    this.handleSetLanguage(value);
    cookieLanguage.set('language', value, 
    {path: '/My-Portfolio',
    expires: nextYear,
  })
}); 

  }

  handleClickAbout = () =>{
    const {t} = this.props;
    const cookieLanguage = new Cookies('language');

      Swal({
      title: t('about.title'),
      text: t('about.description'),
  })
  }

  handleClickDisclaimer = () =>{
    const {t} = this.props;
    const cookieLanguage = new Cookies('language');

      Swal2.fire({
      title: t('disclaimer.title'),
      html: t('disclaimer.description') + disclaimerTextUrl,
  })
  }


    render(){

      const {t} = this.props;

        return(
            <div className="burgerMenuContainer" id="burgerMenuContainer">
            <Menu right className="burgerMenu" styles={styles}>

                <div className="burgerMenuItemDiv">
                  <Link to="/My-Portfolio" className="menu-item burgerText">{t('burgerMenu.home')}</Link>
                </div>

                <div className="burgerMenuItemDiv">
                  <h2 className="menu-item burgerText" onClick={this.handleClickLanguage}>{t('burgerMenu.language')}</h2>
                </div>

                <div className="burgerMenuItemDiv">
                  <h2 className="menu-item burgerText" onClick={this.handleClickAbout}>{t('burgerMenu.about')}</h2>
                </div>

                <div className="burgerMenuItemDiv">
                  <h2 className="menu-item burgerText" onClick={this.handleClickDisclaimer}>Disclaimer <i className="fas fa-info-circle disclaimer"/> </h2>
                  
                </div>
             
                  <div className="burgerMenuFooter">
                    <a href="https://github.com/4nR3" target="_blank">
                      <i className="fab fa-github socialMedias" />
                    </a>

                    <a href="https://www.linkedin.com/in/andr%C3%A9-alvarez-574160208/" target="_blank">
                      <i className="fab fa-linkedin socialMedias"  />
                    </a>
                   
                  </div>
                
                  <div>
                    <h2>{builVersion}</h2>
                  </div>

            </Menu>
             
           </div>
        )
    }


}

BurgerMenu.propTypes = {
    t:PropTypes.func.isRequired,
}

export default translate(BurgerMenu);